/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import Tamil from '../lang/ta.json';
import English from '../lang/en.json';
import { storageGetItem, storageSetItem, getAccessToken, getBusinessId } from '../../../../helpers/utilities';
import authActions from "../../../../layouts/Auth/redux/actions";
import adminActions from "../../../../layouts/Admin/Home/redux/actions";
import businessActions from "../../../../layouts/Admin/Home/redux/actions";
import addressActions from "../../../../layouts/Admin/Address/redux/actions";
import { useDispatch } from "react-redux";

export const Context = React.createContext();
const local = storageGetItem('locale') ? storageGetItem('locale') : navigator.language;

let lang;
if (local === 'en-US') {
    lang = English;
} else {
    if (local === 'ta') {
        lang = Tamil;
    }
}


const Wrapper = (props) => {
    const [locale, setLocale] = useState(local);
    const [messages, setMessages] = useState(lang);
    const dispatch = useDispatch();

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        if (getAccessToken()) {
            dispatch({ type: businessActions.BUSINESS_DETAILS_START });
            dispatch({ type: authActions.ROLE_MANAGEMENT_START });
            dispatch({ type: adminActions.SUBSCRIPTION_DETAILS_START });
            dispatch({ type: adminActions.PARAMETER_DETAILS_START, url: `business-parameters/${getBusinessId()}` });
            dispatch({ type: addressActions.LANGUAGE_DETAILS_START, filter: { order: 'id  desc' } });
        }
    }

    function selectLanguage(e) {
        const newLocale = e.target.value;
        setLocale(newLocale);
        if (newLocale === 'en-US') {
            setMessages(English);
        } else {
            if (newLocale === 'ta') {
                setMessages(Tamil);
            }
        }
        storageSetItem('locale', newLocale);
    }

    return (
        <Context.Provider value={{ locale, selectLanguage }}>
            <IntlProvider messages={messages} locale={locale}>
                {props.children}
            </IntlProvider>
        </Context.Provider>
    );
}


export default Wrapper;